import { TAScanValues } from '../api/slice/types';
import { TypedRootState } from '../types';

export const selectPrevAScanData = (state: TypedRootState): TAScanValues => state.prevAScanData;
